import React from 'react'
import { Link } from 'react-router-dom'

export default class LoginLink extends React.Component {
  render() {
    return (
      <Link to='/login'>
        { this.props.children ? this.props.children : 'Login'}
      </Link>
    )
  }
}
